<template lang='pug' src='./AdminUsers.pug'></template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import { buildPayloadPagination } from '@/utils/utils.js'
import { ValidationProvider, ValidationObserver, localize } from "vee-validate"

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      name: '',
      email: '',
      hotspot: '',
      hotspots: [],
      rules: ['admin', 'user'],
      permissoes: 'admin',
      //----------------------
      dialogHS: false,
      //----------------------
      dialog: false,
      confirmDialog: false,
      //users: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        email: '',
        id: '',
      },
      defaultItem: {
        name: '',
        email: '',
        id: '',
      },
      //----------------------
      chips: '',
      userName: '',
      userId: '',
      userHotspots: [],

      searchInput: '',
      dataTableLoading: true,
      delayTimer: null,
      search: '',
      // editedItem: {},
      //defaultItem: {},
      pagination: {
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        sortBy: ['nome'],
        sortDesc: ['true']},
      fieldsToSearch: ['name', 'email'],
      password: '',
      hotspotSelected: [],
      userToDelete: [],
      typeToRemove: '',
      isEditing: false,
      isUnauthorizedHotspot: false
    }
  },
  methods: {
    ...mapGetters(['isTokenSet']),
    ...mapActions(['saveUser', 'getUsers', 'getHotspots', 'editUser', 'deleteUser']),
    async onSubmit() {
      if(this.isEditing == false){
        this.save()
      }else{
        this.edit()
      }
    },

    canAddHotspot(newHotspot){

      if(this.user.role != 'super'){
        // console.log(newHotspot)
        // console.log(this.user.hotspots)
        // console.log(this.user.hotspots.indexOf(newHotspot))
        if(this.user.hotspots.indexOf(newHotspot) == -1){
          return false
        }
      }
      return true
    },

    async addHsSubmit() {

        if(this.canAddHotspot(this.chips)){

          if(this.userHotspots.indexOf(this.chips) == -1){ // hotspot ainda não pertence ao usuário
            this.userHotspots.push(this.chips)
            await this.editUser({
              '_id': this.userId,
              'hotspots': this.userHotspots
            })
          }
          this.close()

        }else{
          this.isUnauthorizedHotspot = true
        }
    },
    async initialize () {
      this.setPassword(null)
    },

    setPassword(value){
      if(value == null){
        this.isEditing == false
        this.password = Math.random().toString(36).slice(-8);
      }else{
        this.password = value
      }
    },

    async save() {

      if(this.canAddHotspot(this.chips)){

        const valid = await this.$refs.form.validate()
        if (valid) {
          if(this.editedItem != null){
            await this.saveUser({
              role: this.permissoes,
              name: this.editedItem.name,
              email: this.editedItem.email,
              password: this.password,
              hotspots: [this.chips]
            })
            this.close()
          }
        }
        await this.getUsers(
          buildPayloadPagination(this.pagination, this.buildSearch())
        )
        this.dataTableLoading = false
      }else{
        this.isUnauthorizedHotspot = true
      }
    },

    editItem (item) {
      this.setPassword('********')
      this.userId = item._id
      this.userHotspots = item.hotspots
      this.isEditing = true

      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    addHotspot(item) {
      this.dialogHS = true
      this.userName = item.name
      this.userId = item._id
      this.userHotspots = item.hotspots
    },
    remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
        this.chips = [...this.chips]
    },

    deleteItem (item) {
      const index = this.users.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.users.splice(index, 1)
    },

    close () {
      this.dialog = false
      this.dialogHS = false
      this.isEditing = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    openConfirmationDialog(type, key, item){

      this.typeToRemove = type
      if(type == 'hotspot'){
        this.hotspotSelected = [key, item]
      }else{
        this.userToDelete = [item]
      }
      this.confirmDialog = true

    },

    removeItem () {
      if(this.typeToRemove == 'hotspot'){
        this.removeHotspot()
      }else{
        this.removeUser()
      }
    },

    async removeUser () {
      this.confirmDialog = false
      const item = this.userToDelete[0]

      const index = this.items.indexOf(item)
      await this.deleteUser({
        '_id': item._id,
      })
      this.items.splice(index, 1)
    },

    async removeHotspot () {

      this.confirmDialog = false
      const hs = this.hotspotSelected[0]
      const item = this.hotspotSelected[1]

      var index = item.hotspots.indexOf(hs);
      if (index !== -1) item.hotspots.splice(index, 1);

      await this.editUser({
        '_id': item._id,
        'role': item.role,
        'hotspots': item.hotspots,
        'verified': item.verified,
        'name': item.name,
        'email': item.email,
      })

    },

    async edit(){
      if(this.userHotspots.indexOf(this.chips) == -1 && this.chips != ''){ this.userHotspots.push(this.chips) }

      if(this.editedItem != null){
        await this.editUser({
          '_id': this.userId,
          role: this.permissoes,
          name: this.editedItem.name,
          email: this.editedItem.email,
          hotspots: this.userHotspots
        })
      }
      this.close()
      await this.getUsers(
        buildPayloadPagination(this.pagination, this.buildSearch())
      )
      this.dataTableLoading = false
    },

    async doSearch() {
      this.pagination.identity = window.localStorage.getItem('selectedHotspot').split('"').join('')
      try {
        this.dataTableLoading = true
        await this.getUsers(
          buildPayloadPagination(this.pagination, this.buildSearch())
        )
        this.dataTableLoading = false
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        this.dataTableLoading = false
      }
    },
    buildSearch() {
      return this.search
        ? { query: this.search, fields: this.fieldsToSearch.join(',') }
        : {}
    },
  },
  computed: {
    ...mapGetters(['user']),
    headers() {
      return [
        {
          text: `${this.$t('adminuser.TABLEUSERNAME')}`,
          align: 'left',
          value: 'name',
        },
        { text: 'E-mail', value: 'email' },
        { text: `${this.$t('adminuser.TABLEACTIONS')}`, value: 'action'},
      ]
    },

    lang(){
      return this.$store.getters.locale
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    items() {
      return this.$store.state.adminUsers.users
    },
    totalItems() {
      return this.$store.state.adminUsers.totalUsers
    },
    selectedHs () {
      return this.$store.state.adminHotspots.selectedHotspot
    },
    // hotspots() {
    //   //const hotspotsIdentitys = this.$store.state.adminHotspots.hotspots.map(x => x.identity)
    //   // hotspotsIdentitys = window.localStorage.getItem('hotspots')
    //   return this.user.hotspots
    // },
    // password() {
    //   return Math.random().toString(36).slice(-8);
    // }
  },
  watch: {
    selectedHs () {
      this.doSearch()
    },
    lang (newLang) { // se trocou a linguagem, revalida o form
      const lg = { en: en, pt: pt_BR, es: es };
      localize(`${newLang}`, lg[newLang]);

      if(this.$refs.form != null){ this.$refs.form.validate() }
    },
    dialog (val) {
      val || this.close()
    },
    pagination: {
    async handler() {
      try {
        this.dataTableLoading = true
        await this.getUsers(
          buildPayloadPagination(this.pagination, this.buildSearch())
        )
        this.dataTableLoading = false
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        this.dataTableLoading = false
      }
    },
    deep: true
  },
  search() {
    clearTimeout(this.delayTimer)
    this.delayTimer = setTimeout(() => {
      this.doSearch()
    }, 400)
  }
  },
  async created () {
    this.hotspots = this.user.hotspots
    this.initialize()
  },
}
</script>
